import * as types from './actionTypes';
import woMenCustomizeApi from '../api/woMenCustomizeApi';
// import Swal from 'sweetalert2'

export function doWoMenCustomize(data) {

    return{
        type: types.DO_WOMENCUSTOMIZE,
        data
    };
}

export function doWoMenCustomizeRes(user) {
    return{
        type: types.DO_WOMENCUSTOMIZE_RES,
        user
    };
}

export function detailsWoMenCustomize(data) {
    return function (dispatch) {
        woMenCustomizeApi.doWoMenCustomize(data).then(res => {
            dispatch(doWoMenCustomizeRes(res));
            
        }).catch(error => {
            return error
        });
    };
}